import { useForm, FormProvider } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { EmailFormField, TermsFormField } from "@/components/molecules";
import React, { useEffect, useState } from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { SignInLink } from "@/components/atoms/SignInLink";

export type ProvisionalRegistrationFormValues = {
  email: string;
  termOfUse: boolean;
  specialTerm: boolean;
  privacyPolicy: boolean;
  adEmailDelivery: boolean;
};

type Props = {
  onSubmit: (formValues: ProvisionalRegistrationFormValues) => void;
};

export const ProvisionalRegistrationForm = (props: Props) => {
  const isSpMode = useIsSpMode();

  const methods = useForm<ProvisionalRegistrationFormValues>({
    reValidateMode: "onBlur",
  });

  const [agreed, setAgreed] = useState(false);

  const formValues = methods.getValues();
  useEffect(() => {
    setAgreed(
      formValues.termOfUse &&
        formValues.specialTerm &&
        formValues.privacyPolicy &&
        formValues.adEmailDelivery
    );
  }, [formValues]);

  return (
    <>
      <div css={container}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(props.onSubmit)} css={formCSS}>
            <div css={!isSpMode ? borderBox : borderSpModeBox}>
              <div css={!isSpMode ? inputList : spModeInputList}>
                <EmailFormField name="email" />
              </div>
            </div>
            <div css={!isSpMode ? box : spModeBox}>
              <TermsFormField
                termOfUse="termOfUse"
                specialTerm="specialTerm"
                privacyPolicy="privacyPolicy"
                adEmailDelivery="adEmailDelivery"
              />
            </div>
            <div css={buttonWrapper}>
              <Button
                type="submit"
                disabled={methods.formState.isSubmitting || !agreed}
              >
                登録
              </Button>
            </div>
          </form>
        </FormProvider>
      </div>
      <div css={signInLink}>
        <SignInLink />
      </div>
    </>
  );
};

const signInLink = css({
  textAlign: "center",
});

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  margin: "0 auto",
});

const spModeBox = css({
  padding: "15px 17px",
});

const borderBox = css(box, {
  border: `1px solid ${color.iron}`,
  padding: "32px",
  borderRadius: "4px",
});

const borderSpModeBox = css(spModeBox, {
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const formCSS = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const buttonWrapper = css({
  margin: "40px auto",
});
